module.exports = __webpack_public_path__ + "img/27_7.e89cf824.png";